import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/37_heart_roses/37_heart_roses"
 * Contains 1 texture(s)
 */
export class Desktop37HeartRosesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/37_heart_roses/37_heart_roses';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '37_heart_roses.png'
    ] as const;
}
